
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/residential-storage-fee",
      function () {
        return require("private-next-pages/residential-storage-fee/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/residential-storage-fee"])
      });
    }
  